// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ScheduledJobs_JobRow.php
// Do not edit by hand — edit the PHP RowContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ScheduledJobs_JobRow — one row of `scheduled_jobs` for the Full-only
 * console (list, and the single-row echo after save/toggle/run-now).
 *
 * Datetime fields are ISO-8601 UTC strings — the controller converts from
 * the GMT-3 storage format before building this row (Typed Data Layer rule).
 *
 * `heartbeat_stale` is DERIVED by the controller, not stored: true when
 * `last_success_at` is older than a threshold computed FROM the job's own
 * schedule (>26h for 'daily', >3× interval_minutes for 'interval') — a
 * franchise's own dashboard alarm, deliberately not a staff-editable number
 * (see docs/billing-uplift-decision-log.md § S10 ATENÇÃO, "'skipped' conta
 * como batimento saudável").
 */
import { registerContract } from './validate'

export interface ScheduledJobs_JobRow {
id: number
name?: string
job_type?: string
enabled?: boolean
schedule_kind?: string
schedule_time?: string
interval_minutes?: number
params?: string
channel?: string
channel_target?: string
max_attempts?: number
next_run_at?: string
last_run_at?: string
last_success_at?: string
created_at?: string
updated_at?: string
heartbeat_stale?: boolean
}

registerContract('ScheduledJobs_JobRow', {
  id:               { type: 'number',  required: true },
  name:             { type: 'string',  required: false },
  job_type:         { type: 'string',  required: false },
  enabled:          { type: 'boolean', required: false },
  schedule_kind:    { type: 'string',  required: false },
  schedule_time:    { type: 'string',  required: false },
  interval_minutes: { type: 'number',  required: false },
  params:           { type: 'string',  required: false },
  channel:          { type: 'string',  required: false },
  channel_target:   { type: 'string',  required: false },
  max_attempts:     { type: 'number',  required: false },
  next_run_at:      { type: 'string',  required: false },
  last_run_at:      { type: 'string',  required: false },
  last_success_at:  { type: 'string',  required: false },
  created_at:       { type: 'string',  required: false },
  updated_at:       { type: 'string',  required: false },
  heartbeat_stale:  { type: 'boolean', required: false },
})
